import { DotLegalSelectOption } from "../common/components/dotLegalMultiSelect/DotLegalMultiSelect.types";
import { useTranslation } from "../localization/useTranslation";
import { DocumentStatus } from "./Documents.types";

export function useDocumentHook() {
    const { translateString } = useTranslation();

    const selecableDocumentStatus: Array<DotLegalSelectOption> = [
        { name: translateString(DocumentStatus[DocumentStatus.draft]).toString(), id: DocumentStatus.draft.toString() },
        { name: translateString(DocumentStatus[DocumentStatus.signed]).toString(), id: DocumentStatus.signed.toString() },
        { name: translateString(DocumentStatus[DocumentStatus.active]).toString(), id: DocumentStatus.active.toString() },
        { name: translateString(DocumentStatus[DocumentStatus.archived]).toString(), id: DocumentStatus.archived.toString() },
    ];

    return { selecableDocumentStatus };
}
